import React, { useState } from 'react';
import { Container, Button, Alert, Spinner, Row, Col } from 'react-bootstrap';
import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase.js';

export default function AdminFixData() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const fixSandraActiveSessions = async () => {
    try {
      setLoading(true);
      setMessage(null);
      setError(null);

      // Busca todos os registros ativos da Sandra
      const q = query(
        collection(db, 'timeTrackings'),
        where('displayName', '==', 'Sandra'),
        where('status', '==', 'active')
      );

      const snapshot = await getDocs(q);
      console.log(`Encontrados ${snapshot.size} registros ativos da Sandra`);

      if (snapshot.size === 0) {
        setMessage('Nenhum registro ativo da Sandra encontrado.');
        setLoading(false);
        return;
      }

      // Atualiza cada documento para 'completed'
      let updated = 0;
      for (const docSnap of snapshot.docs) {
        await updateDoc(doc(db, 'timeTrackings', docSnap.id), {
          status: 'completed'
        });
        updated++;
        console.log(`Desativado: ${docSnap.id}`);
      }

      setMessage(`✅ ${updated} registros da Sandra foram desativados com sucesso! Recarregando página em 2 segundos...`);
      setLoading(false);

      // Recarrega a página após 2 segundos
      setTimeout(() => {
        window.location.href = '/admin/tracking';
      }, 2000);
    } catch (err) {
      console.error('Erro:', err);
      setError(`Erro ao desativar registros: ${err.message}`);
      setLoading(false);
    }
  };

  return (
    <Container fluid className="py-4">
      <Row>
        <Col md={8} className="mx-auto">
          <h2>🔧 Ferramentas de Manutenção</h2>
          <hr />

          {message && <Alert variant="success">{message}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}

          <div className="card p-4">
            <h5>Desativar Todas as Sessões Ativas da Sandra</h5>
            <p className="text-muted">
              Isso vai marcar como "completed" todos os registros da Sandra que estão com status "active".
            </p>
            <Button
              variant="danger"
              disabled={loading}
              onClick={fixSandraActiveSessions}
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Processando...
                </>
              ) : (
                '🔄 Desativar Agora'
              )}
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
